import { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { dismissNotification } from '../../../actions/notifications'
import {
  MATERIAL_CHANGE_NOTIFICATION,
  AP_NOTIFICATIONS,
} from '../../../constants/NotificationConstants'

const mapStateToProps = state => {
  const {
    user: {
      data: { selectedOrgId, isCSR, isSchoolAdmin },
    },
    settingsEducationPeriod: { selectedEducationPeriod: educationPeriodCd },
  } = state
  const { data, fetching, error } = state.notifications[AP_NOTIFICATIONS]
  const notifications = data?.filter(
    notification => notification.messageType === MATERIAL_CHANGE_NOTIFICATION
  )
  return {
    orgId: selectedOrgId,
    educationPeriodCd,
    isCSR,
    isSchoolAdmin,
    notifications,
    fetching,
    error,
  }
}

const CoordinatorMaterialChangeNotification = ({
  orgId,
  educationPeriodCd,
  notifications,
  isCSR,
  isSchoolAdmin,
  error,
  dismissNotification,
}) => {
  const [expanded, setExpanded] = useState(false)
  const [show, setShow] = useState(true)
  const notificationCount = notifications ? notifications.length : 0
  const visibleData = notificationCount
    ? expanded
      ? notifications
      : notifications.slice(0, 1)
    : []

  const removeMergeNotification = () => {
    setShow(false)
    dismissNotification({
      orgId,
      educationPeriodCd,
      notificationType: MATERIAL_CHANGE_NOTIFICATION,
      messageIds: notifications.map(n => n.messageId),
    })
  }

  if (isCSR || isSchoolAdmin) return null

  if (notificationCount && show && !error) {
    return (
      <div
        role="alert"
        className="alert alert-warning cb-alert-heading notification"
        style={{ marginTop: -21, border: 0, backgroundColor: 'rgb(0, 119, 200, .15)' }}
      >
        <div className="container" style={{ position: 'relative' }}>
          <h2>Student Materials Changed</h2>
          {visibleData.map(d => (
            <Fragment key={d.messageId}>
              <p>{d.message}</p>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1em' }}
              >
                <p>
                  Please review the changes and submit the pending order changes on the Orders page.
                </p>
                <Link
                  to={`/student/${d.studentId}`}
                  style={{
                    marginLeft: '15px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <strong>View Student details</strong>
                  <i
                    className="cb-glyph cb-east"
                    aria-hidden={true}
                    style={{ marginLeft: 5, fontSize: '.9em' }}
                  />
                </Link>
              </div>
            </Fragment>
          ))}
          {notificationCount > 1 ? (
            <p style={{ marginBottom: 0 }}>
              <button
                type="button"
                className="btn-link"
                aria-expanded={expanded}
                onClick={() => setExpanded(!expanded)}
                style={{ padding: 0, border: 0, fontWeight: 700 }}
              >
                see {expanded ? 'less' : 'more'}
                <i
                  className={`cb-glyph ${expanded ? 'cb-minus' : 'cb-plus'}`}
                  aria-hidden={true}
                  style={{ fontSize: '.8em', paddingLeft: 3 }}
                />
              </button>
            </p>
          ) : null}
          <button
            type="button"
            className="close"
            style={{ position: 'absolute', top: '-15px', right: 30 }}
            onClick={removeMergeNotification}
          >
            <span className="sr-only">close</span>
          </button>
        </div>
      </div>
    )
  }
  return null
}

export default connect(mapStateToProps, { dismissNotification })(
  CoordinatorMaterialChangeNotification
)
